import Vue from 'vue'

const axios = require('axios').default
export default class Widget {
	private mode = ''
	private infos = {
		agentid: 0,
		alias: '',
		firstname: '',
		lastname: '',
		title: '',
		showmail: 0,
		email: '',
		showphone: 0,
		phone: '',
		homelink: '',
		fblink: '',
		twitterlink: '',
		agentForConcours: '0'
	}

	private concoursimage = ''

	async getAgentIdent() {
		const hash = location.hash.replace('#', '')
		if (hash.length > 0) {
			const self = this
			if (hash.indexOf('AG|') === 0 || hash.indexOf('AG%7C') === 0) {
				return axios.post(`${process.env.VUE_APP_VED_AGENT_URL}getagentwidget.php`, {agentid: hash}).then((response: any) => {
					if (response.data.status === 'OK') {
						self.mode = response.data.mode
						self.infos = response.data.infos
						self.concoursimage = response.data.concoursimg
						if (self.mode === 'AGENT') {
							Vue.prototype.$cookies.set('agent', self.infos.agentid, {expires: '1d'})
						} else {
							Vue.prototype.$cookies.set('agent', self.infos.alias, {expires: '1d'})
						}
						return true
					} else {
						return false
					}
				})
			} else {
				return axios.post(`${process.env.VUE_APP_VED_AGENT_URL}getagentwidget.php`, {postid: hash}).then((response: any) => {
					if (response.data.status === 'OK') {
						self.mode = response.data.mode
						self.infos = response.data.infos
						self.concoursimage = response.data.concoursimg
						if (self.mode === 'AGENT') {
							Vue.prototype.$cookies.set('agent', self.infos.agentid, {expires: '1d'})
						} else {
							Vue.prototype.$cookies.set('agent', self.infos.alias, {expires: '1d'})
						}
						return true
					} else {
						return false
					}
				})
			}
		} else {
			const curagent = Vue.prototype.$cookies.get('agent')
			if (curagent) {
				// on va aller chercher les infos de cet agent par call ajax
				const self = this
				return axios.post(`${process.env.VUE_APP_VED_AGENT_URL}getagentwidget.php`, {agentid: curagent}).then((response: any) => {
					if (response.data.status === 'OK') {
						self.mode = response.data.mode
						self.infos = response.data.infos
						self.concoursimage = response.data.concoursimg
						return true
					} else {
						return false
					}
				})
			} else {
				return false
			}
		}
	}

	getFullname() {
		if (this.mode === 'AGENT') {
			return this.infos.firstname + ' ' + this.infos.lastname
		} else {
			return this.infos.firstname
		}
	}

	getImage() {
		if (this.mode === 'AGENT') {
			return `${process.env.VUE_APP_VED_IMAGES_URL}/agents/thumbs/${this.infos.agentid}_0.jpg`
		} else {
			if (this.infos.alias.toUpperCase() === 'VED') {
				return `${process.env.VUE_APP_VED_AGENT_URL}thumbnail/ved_e.png`
			} else {
				return `${process.env.VUE_APP_VED_AGENT_URL}thumbnail/agency.jpg`
			}
		}
	}

	getSubtitle() {
		return this.infos.title
	}

	canShowEmail() {
		return this.infos.showmail.toString() === '1'
	}

	getEmail() {
		return this.infos.email
	}

	canShowPhone() {
		return this.infos.showphone.toString() === '1'
	}

	getPhone() {
		return this.infos.phone
	}

	getHomelink() {
		return this.infos.homelink
	}

	getFbLink() {
		return this.infos.fblink
	}

	getTwitterLink() {
		return this.infos.twitterlink
	}

	getAgentId() {
		if (this.mode === 'AGENT') {
			return this.infos.agentid
		} else {
			return 0
		}
	}

	getAlias() {
		return this.infos.alias.toUpperCase()
	}

	getAgentForConcours() {
		if (this.infos.agentForConcours === '0') {
			return null
		} else {
			return this.infos.agentForConcours
		}
	}

	getAllInfos() {
		return this.infos
	}

	getMode() {
		return this.mode
	}

	getConcoursImage() {
		return `${process.env.VUE_APP_VED_AGENT_URL}general_images/${this.concoursimage}`
	}
}
